import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../config/axios'
import { RootState } from '../store'

export interface ImageState {
  loading: boolean
  signedUrl: string
  error: string | null
}

const initialState: ImageState = {
  loading: false,
  signedUrl: '',
  error: null,
}

// Generates pending, fulfilled, and rejected action types
export const fetchSignedUrl = createAsyncThunk(
  'image/fetchSignedUrl',
  async ({
    fileType,
    fileName,
    moduleName,
  }: {
    fileType: string
    fileName: string
    moduleName: string
  }) => {
    return axios
      .get(`/image/getSignedUrl`, {
        params: { fileType, fileName, moduleName },
      })
      .then((response) => response.data)
  },
)

export const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    storeSignedUrl: (state, action: PayloadAction<string>) => {
      state.signedUrl = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSignedUrl.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchSignedUrl.fulfilled, (state, action: PayloadAction<string>) => {
      state.loading = false
      state.signedUrl = action.payload
      state.error = null
    })
    builder.addCase(fetchSignedUrl.rejected, (state, action) => {
      state.loading = false
      state.signedUrl = ''
      state.error = action.error.message || 'Failed to fetch signed URL'
    })
  },
})

export default imageSlice.reducer

// Selector to access the signed URL and loading/error state
export const selectSignedUrl = (state: RootState) => state.image.signedUrl
export const selectImageLoading = (state: RootState) => state.image.loading
export const selectImageError = (state: RootState) => state.image.error
